import { render, staticRenderFns } from "./tableItem.vue?vue&type=template&id=3ffd2062&scoped=true"
import script from "./tableItem.vue?vue&type=script&lang=js"
export * from "./tableItem.vue?vue&type=script&lang=js"
import style0 from "./tableItem.vue?vue&type=style&index=0&id=3ffd2062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffd2062",
  null
  
)

export default component.exports